export default "__VITE_ASSET__g_AhL0HF__"